import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { borderRadius3, colorBgInteractiveActive, space4, colorText, colorIconLight } = theme();
    return StyleSheet.create({
        aspectRatioView: {
            width: "100%",
        },
        button: {
            alignItems: "center",
            backgroundColor: colorBgInteractiveActive,
            borderRadius: borderRadius3,
            flexDirection: "column",
            flex: 1,
            justifyContent: "center",
            paddingHorizontal: space4,
            paddingVertical: space4,
        },
        container: {
            flex: 1,
        },
        icon: {
            color: colorIconLight,
        },
        text: {
            color: colorText,
            padding: 0,
            textAlign: "center",
        },
    });
};
export { style };
